module.exports = __webpack_public_path__ + "img/index_smmonth.6297ef60.png";